<template>
	<div id="save-cart-for-service">
		
		<div class="section customer" v-if="!user.isAdmin">
			<div class="container">
				<button id="save-cart" @click="postCartToServer()">
					<span class="text">שמירת עגלה לתמיכה מרחוק</span>
					<img class="spinner" :src="wpData.assets_url + '/svg/loader.svg'" alt="Loading...">
				</button>
				<p class="result">{{customerNotice}}</p>
			</div>
		</div>

		<div class="admin section" :class="{'initial-loading':savedCarts.length === 0} " v-if="user.isAdmin">
			<div class="loader">
				<p>טוען עגלה...</p>
			</div>
			<div class="initial-loader">
				<p>טוען עגלות שמורות</p>
				<img class="spinner" :src="wpData.assets_url + '/svg/loader.svg'" alt="Loading...">
			</div>
			<div class="wrapper" v-if="savedCarts.length > 0">
				<h2>עגלות שמורות לתמיכה  מרחוק</h2>
				<br/>
				<table>
					<tr>
						<th class="">שם לקוח</th>
						<th class="">מייל לקוח</th>
						<th class="">תאריך יצירה</th>
						<th class="">כמות פריטים בעגלה</th>
						<th class="">התקעת כל העגלה</th>
						<th class="">העתקת חלק העגלה</th>
					</tr>
					<tr v-for="row in savedCarts" :key="row.cart_id">
						<td class="cscfs-right">{{row.user ? row.user.name : 'משתמש לא מזוהה'}}</td>
						<td class="cscfs-left">{{row.user ? row.user.email : 'משתמש לא מזוהה'}}</td>
						<td class="cscfs-center">{{row.time}}</td>
						<td class="cscfs-center">{{row.num_items_in_cart}}</td>
						<td><button class="copy-cart" @click="copyCart($event, row.filename)">העתקה לעגלה שלי</button></td>
						<td v-if="row.num_items_in_cart / 50 > 1">
							<button
								class="copy-cart copy-cart-part"
								v-for="i in Math.ceil(row.num_items_in_cart / 50)"
								@click="copyCartPart($event, row.filename, i)"
							>
								{{i}}
							</button>
						</td>
					</tr>
				</table>
			</div>
		</div>

	</div>
</template>

<script>
	import Vuex from 'vuex';
	export default {
		name: 'SaveCartForService',
		data () {
			return {
				wpData: window.wpData,
				ajaxUrl: window.wpData.ajax_url,
				cart: this.$store.state.added,
				savedCarts: [],
				user: this.$store.state.userLoggedInfo,
				customerNotice: '',
				cartPartFrom: null,
				cartPartTo: null
			}
		},
		methods: {
			...Vuex.mapMutations([ "clearCart" ]),
			generateJSON(){
				const items = [];
				this.cart.forEach( item => {
					delete item.relatedProducts;
					items.push(item);
				});
				let userID = null;
				let user = null;
				if ( this.$store.state.userLogged ) {
					userID = this.$store.state.userLoggedInfo.id;
					user = {
						id: this.$store.state.userLoggedInfo.id,
						name: this.$store.state.userLoggedInfo.firstname + ' ' + this.$store.state.userLoggedInfo.lastname,
						email: this.$store.state.userLoggedInfo.email
					}
				}
				return { userID, user, items, cart_id: this.generateUniqueID() }
			},
			postCartToServer(){

				const button = document.querySelector('#save-cart');

				if ( button.classList.contains('loading') || button.classList.contains('disabled') ) { return false; }

				button.classList.add('loading');

				let formData = new FormData();
				formData.append('data', JSON.stringify(this.generateJSON()));
				const request = fetch( this.ajaxUrl + '?action=cscfs_saveCart', {
					method: 'POST',
					cache: 'no-cache',
					body: formData
				});
				request.then( r => r.json() )
					.then( data => {
						button.classList.add('disabled');
						button.classList.remove('loading');
						this.customerNotice = 'העגלה שלך נשמרה בהצלחה!';
					});
				return false;
			},
			getSavedCarts(){
				const request = fetch( this.ajaxUrl + '?action=cscfs_listCarts', {
					method: 'GET',
					cache: 'no-cache'
				});
				request.then( r => r.json() )
					.then( r => {
						r = r.sort( (a,b) => {
							if( a.timestamp < b.timestamp ) {
								return 1;
							}
							return -1;
						});
						this.savedCarts = r;
					});
			},
			copyCart( e, path ){
				const section = e.target.closest('.section');
				section.classList.add('loading');

				const fileName = path

				const request = fetch( this.ajaxUrl + '?action=cscfs_getCart&filename=' + path, {
					method: 'GET',
					cache: 'no-cache'
				});
				request.then( r => r.json() )
					.then( r => {
						this.clearCart();
						this.$store.state.added = r;
						this.$store.dispatch('sendCartToServer');
						section.classList.remove('loading');
					});
			},
			copyCartPart( e, path, part ) {
				const section = e.target.closest('.section');
				section.classList.add('loading');

				const fileName = path;
				this.cartPartFrom = (part - 1) * 50;
				this.cartPartTo = this.cartPartFrom + 50;

				const request = fetch( this.ajaxUrl + '?action=cscfs_getCart&filename=' + path, {
					method: 'GET',
					cache: 'no-cache'
				});
				request.then( r => r.json() )
					.then( r => {
						console.log(this.cartPartFrom, this.cartPartTo);
						this.clearCart();
						this.$store.state.added = r.slice(this.cartPartFrom, this.cartPartTo);
						this.$store.dispatch('sendCartToServer');
						section.classList.remove('loading');
					});
			},
			generateUniqueID() {
			    let result = '';
			    const characters= 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
			    var charactersLength = characters.length;
			    for ( var i = 0; i < 6; i++ ) {
					result += characters.charAt(Math.floor(Math.random() * charactersLength));
				}
				return result + '_' + Date.now();
			}

		},
		mounted(){
			if ( this.user.isAdmin ) {
				this.getSavedCarts();
			}
		}
	}
</script>

<style lang="sass" scoped>
	.section
		position: relative	
		padding: 3rem 0

	.wrapper
		padding: 0 3rem
	th, td
		border: 1px solid black
		padding: 0.5rem 1rem
		&.csfs-right
			text-align: right
		&.csfs-left
			text-align: left
		&.csfs-center
			text-align: center
	.copy-cart
		background: #2c8a57
		color: #fff
		outline: none
		border: none
		padding: 0.5rem 1rem
		&:hover, &:focus
			background: #30b56c

	.copy-cart-part
		margin-left: 4px

	.section.loading .loader
		display: flex
	.section.initial-loading .initial-loader
		display: flex

	.loader, .initial-loader
		position: absolute
		top: 0
		left: 0
		width: 100%
		height: 100%
		display: none
		justify-content: center
		align-items: center
		font-size: 2rem
		text-align: center
		background-color: rgba(255,255,255,0.8)

	.initial-loader
		justify-content: flex-start
		background-color: #1e824c
		color: white
		padding: 0 3rem
		img
			margin-right: 2rem

	.section.customer
		margin: 3rem auto

		#save-cart
			margin: 2rem auto 0.5rem auto
			position: relative
			outline: none
			background-color: #f9bf3b
			border: none
			border-radius: 2rem
			padding: 0.75rem 1.25rem
			&.loading
				.spinner
					opacity: 1
				span
					opacity: 0
			&.disabled
				cursor: not-allowed
				background-color: #ccc
		.spinner
			position: absolute
			top: 50%
			left: 50%
			transform: translate(-50%, -50%)
			width: 1.5rem
			height: 1.5rem
			opacity: 0

	/* MOBILE */
	@media screen and (max-width:767px)
		.section.customer
			margin-top: -4rem
			padding-top: 0
</style>